import { IPosition } from './iposition';

export class PositionWrite implements IPosition {
  public id: string;
  public title: string;
  public count: number;
  public description: string;
  public arePeopleSyncedToTeamManager: boolean;
  public eligibilityFilters: string[];
  public eligibilityODataQuery: string;

  constructor(
    title: string,
    count: number,
    arePeopleSyncedToTeamManager: boolean,
    id?: string,
    description?: string,
    eligibilityFilters: string[] = [],
    eligibilityODataQuery: string = null
  ) {
    this.arePeopleSyncedToTeamManager = arePeopleSyncedToTeamManager;
    this.id = id || null;
    this.title = title;
    this.count = count;
    this.description = description;
    this.eligibilityFilters = eligibilityFilters ?? [];
    this.eligibilityODataQuery = eligibilityODataQuery ?? null;
  }
}
